import React, { useEffect, useState } from 'react'
import { BackButton, ClearFilterButton, CreateButton, ExportButton, FilterButton, ImportButton } from '../../../Components/Utils/Buttons'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import SearchBar from '../../../Components/Utils/SearchBar'
import { GetAccess } from '../../../Components/Utils/roles'
import List from '../../../Components/Icons/list'
import Card from '../../../Components/Icons/card'
import Breadcrumb from '../../../Components/Utils/Breadcrumb'


const EquipLayout = (
  {
    getData=() => {},
    setSearchQuery=()=>{},
    CreateAccess= false,
    ImportAccess= false,
    setOpen=()=>{},
    setOpenExport=()=>{},
    children,
    onCreateClick,
    searchValue="",
    searchFun=()=>{},
    isFilter=false,
    setFilterOpen=()=>{},
    newfilter=false,
    ClearFilter=()=>{},
    neededSearch=false,
    showproject=true,
    isCard=true,
    setViewMode=()=>{},
        viewMode="",
        ExportAccess=false,
        total={total},
        quantity={quantity},
itemName = "",  
  unit = ""
}
) => {

  let {pathname} = useLocation()
  const [module,setModule] = useState("")
  const navigate = useNavigate();
         
         const { contractsViewId,id } = useParams();
    
   
  
  useEffect(() =>{
    
      if(pathname == `/Contract-management/contracts/equipments/${contractsViewId}/details/${id}`){
          setModule("Details")
      }
    //   else if(pathname == `/client-management/equiments`){
    //     setModule("Cont. Equipt.")
    // }else if(pathname == `/client-management/contracts`){
    //       setModule("Contract")
    //   }
  },[pathname])

  let LinkItem = [
      // {
      //     label:"Equipment Details",
      //     link:`/Contract-management/contracts/equipments/${contractsViewId}/equipDetails/${id}`,
      //     access:GetAccess("equipment_details_view"),
          
      // },
      {

          label:"Details",

          link:`/Contract-management/contracts/equipments/${contractsViewId}/details/${id}`,
          access:GetAccess("equip_details_view"),
      },
    
     
  ];

  const handleCreateClick = () => {
    if (module === "Details") {
        onCreateClick && onCreateClick(); 
    } else {
      navigate(`${pathname}/create`);
    }
  };



  return(
    <div className=" w-full  h-full py-2 px-4 overflow-hidden">
            
            <div className="md:flex justify-between w-full ">
           
            <Breadcrumb
                  items={[
                    { name: "Contract" },
                   
        
                    { name: module },
                  ]}
                />
                 <div className=" flex justify-end items-center gap-3 ">
           
           <form className="flex items-center gap-3 mx-0" onSubmit={getData}>
          
          {neededSearch &&  <SearchBar handleChange={searchFun}  value={searchValue}/>}

           </form>
           {/* {
               screenSize.width >= "1024" &&(<>
               
               {isCard &&

<div className='flex gap-2'>
<div onClick={() => setViewMode("list")} className={viewMode === "list" ? "bg-baseColor-primary h-8 w-10 rounded-md flex justify-center items-center text-white" : "bg-white h-8 w-10 rounded-md flex justify-center items-center cursor-pointer"}><List/></div>
<div onClick={() => setViewMode("card")} className={viewMode === "card" ? "bg-baseColor-primary h-8 w-10 rounded-md flex justify-center items-center text-white" : "bg-white h-8 w-10 rounded-md flex justify-center items-center cursor-pointer"}><Card/></div>
</div>
}
               </>)
             } */}
           {newfilter && (
 <>
         <BackButton />
    
             <FilterButton label='Filter'  handleClick={()=>{setFilterOpen(true);setSearchQuery("");}} />
             {isFilter&& <ClearFilterButton label='Clear'  handleClick={ClearFilter} />} </>)}
              {ImportAccess && <ImportButton label="Import" handleClick={()=>setOpen(true)}    />}
              {ExportAccess && <ExportButton label="Export" handleClick={()=>setOpenExport(true)}    />}

      {CreateAccess && (
  <div className="relative group">
    <button
      type="button"
      onClick={quantity === total ? undefined : handleCreateClick}
      disabled={quantity === total}
      className={`px-2 py-1 rounded-md font-medium transition-colors
        ${
          quantity === total
            ? "bg-gray-300 text-gray-500 cursor-not-allowed"
            : "bg-baseColor-primary text-white hover:bg-baseColor-dark"
        }`}
    >
      +
    </button>

    {quantity === total && (
      <div className="absolute top-3 z-9999 right-[-80px] mb-2 -translate-x-1/2 whitespace-nowrap 
                      bg-gray-300 text-gray-900 text-xs rounded p-2 opacity-0 
                      group-hover:opacity-100 transition-opacity">
        Quantity has reached the limit
      </div>
    )}
  </div>
)}


                     </div>
            </div>

      <div className="w-full overflow-x-auto whitespace-nowrap scrollbar-hide md:flex  gap-x-10 mt-0.5">
        <div className="inline-flex items-center gap-x-1">
      {LinkItem &&
    LinkItem.map((item, i) => {
      const isActive = item?.link === pathname;
      return (
        item.access && (
          <Link
            to={item?.link}
            key={item?.link}
            className={`px-4 py-1 rounded-t-md text-xs 2xl:text-sm font-medium mt-0.5
              ${isActive 
                ? "bg-baseColor-primary text-white" 
                : "bg-white text-baseColor-primary border-b-2 border-baseColor-primary"
              }`}
          >
            {item?.label || ""}
          </Link>
        )
      );
    })}
</div>
           
     <div className="sm:mt-0 mt-1 h-auto border rounded-full mr-3 md:ml-0 ml-4 border-baseColor-primary text-xs inline-flex w-auto flex-shrink-0 justify-center overflow-hidden">
  <p className="w-auto bg-white text-black px-2 flex items-center justify-center">
    Total
  </p>
  <p className="bg-baseColor-primary w-auto text-white px-2 flex items-center justify-center">
    {total || "0"}
  </p>
</div>

<div className="sm:mt-0 mt-1 h-auto border rounded-full mr-3 md:ml-0 ml-4 border-baseColor-primary text-xs inline-flex w-auto flex-shrink-0 justify-center overflow-hidden">
  <p className="w-auto bg-white text-black px-2 flex items-center justify-center">
    Equipment
  </p>
  <p className="bg-baseColor-primary w-auto text-white px-2 flex items-center justify-center">
    {itemName || "-"}
  </p>
</div>

<div className="sm:mt-0 mt-1 h-auto border rounded-full mr-3 md:ml-0 ml-4 border-baseColor-primary text-xs inline-flex w-auto flex-shrink-0 justify-center overflow-hidden">
  <p className="w-auto bg-white text-black px-2 flex items-center justify-center">
    Unit
  </p>
  <p className="bg-baseColor-primary w-auto text-white px-2 flex items-center justify-center">
    {unit || "-"}
  </p>
</div>

<div className="sm:mt-0 mt-1 h-auto border rounded-full mr-3 md:ml-0 ml-4 border-baseColor-primary text-xs inline-flex w-auto flex-shrink-0 justify-center overflow-hidden">
  <p className="w-auto bg-white text-black px-2 flex items-center justify-center">
    Quantity
  </p>
  <p className="bg-baseColor-primary w-auto text-white px-2 flex items-center justify-center">
    {quantity || "-"}
  </p>
</div>
    

    </div>
         
    
          
           
            <div className=" w-full h-[calc(100vh-211px)] md:h-[calc(100vh-165px)]  ">
               {children} 
            </div>
            </div>
       
)
    }
export default EquipLayout